import {takeEvery} from 'redux-saga/effects'
import {
  SP_EXAM_GET_EXAM,
  SP_EXAM_GET_EXAMS,
  SP_EXAM_GET_EXAM_TYPES,
  SP_EXAM_GET_PERFORMANCE,
  SP_EXAM_GET_REPORT_CARD,
  SP_EXAM_GET_REPORT_CARDS,
  SP_EXAM_GET_REPORT_CARD_PDF,
  SP_EXAM_GET_TERMS,
} from 'setup/redux/Actions/SpExam/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

/** Student/parent exam screens (list, detail, report cards, performance). */
function* spExamSagas() {
  yield takeEvery(SP_EXAM_GET_EXAMS, fetchData)
  yield takeEvery(SP_EXAM_GET_EXAM, fetchData)
  yield takeEvery(SP_EXAM_GET_EXAM_TYPES, fetchData)
  yield takeEvery(SP_EXAM_GET_TERMS, fetchData)
  yield takeEvery(SP_EXAM_GET_REPORT_CARDS, fetchData)
  yield takeEvery(SP_EXAM_GET_REPORT_CARD, fetchData)
  yield takeEvery(SP_EXAM_GET_REPORT_CARD_PDF, fetchData)
  yield takeEvery(SP_EXAM_GET_PERFORMANCE, fetchData)
}

export default spExamSagas
